import { getCategoryName } from './getCategoryName'
import { deepValue } from '@corratech/pylot-utils'
import { formatPrice } from '@corratech/pylot-seo'
import { ProductInterface, CategoryTree } from '@pylot-data/pylotschema'

type ProductDetailsItem = {
    id: string
    name: string
    price: string
    category: string
    position: number
    brand: string
    list: string
}

type ProductDetailsInput = {
    currentPage?: string
    pageSize?: string
    searchTerm?: string
    list?: string
    items?: ProductInterface[]
} & Partial<CategoryTree>

const isCategoryTreeInput = (
    input: ProductDetailsInput
): input is CategoryTree => {
    return typeof input.products !== 'undefined'
}

export const getMapProductDetails = (
    categoryName = getCategoryName
): ((data: ProductDetailsInput) => ProductDetailsItem[]) => {
    return (data: ProductDetailsInput): ProductDetailsItem[] => {
        const productsDetails: ProductDetailsItem[] = []
        const startingPosition =
            data.currentPage && data.pageSize
                ? (parseInt(data.currentPage) - 1) * parseInt(data.pageSize)
                : 0
        let currentCategoryName = isCategoryTreeInput(data)
            ? categoryName(data)
            : undefined

        const list =
            typeof data.searchTerm != 'undefined'
                ? `Search Results - ${data.searchTerm}`
                : `Category - ${currentCategoryName}`

        const items = deepValue(data, ['products', 'items'], data.items)
        items.forEach((item: ProductInterface, index: number) => {
            if (!currentCategoryName) {
                currentCategoryName = categoryName(item)
            }
            const price = deepValue(item, [
                'price_range',
                'minimum_price',
                'final_price',
                'value'
            ])
            productsDetails.push({
                id: String(item.sku),
                name: String(item.name),
                price: formatPrice(price),
                category: currentCategoryName,
                position: startingPosition + index + 1,
                brand: deepValue(item, ['brand_name']),
                list: list
            })
        })

        return productsDetails
    }
}
